/* eslint-disable camelcase */
angular.module('commerce')
    .filter('licenseName', ['gettextCatalog', function(gettextCatalog) {
        return function(key) {
            return {
                trial: gettextCatalog.getString('Trial'),
                basic: gettextCatalog.getString('Basic'),
                standard: gettextCatalog.getString('Standard'),
                advanced: gettextCatalog.getString('Advanced'),
                advanced_plus: gettextCatalog.getString('Advanced Plus'),
                non_regulated: gettextCatalog.getString('Non-regulated'),
                regulated: gettextCatalog.getString('Regulated'),
            }[key] || key;
        };
    }]);
